import React from 'react'

export const Cooking = () => {
  return (
    <div className='h-fit w-full overflow-hidden'>
      <div className="flex h-[100vh] items-center justify-center">
        <h1>Page Under Construction, Stay Tuned!</h1>
      </div>
    </div>
  )
}
